import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from '../components/RequireAuth.tsx';
import RequireSelectedSocio from '../components/RequireSelectedSocio.tsx';
import Dashboard from '../components/Dashboard.tsx';
import CuotasTable from '../components/CuotasTable.tsx';
import NotificationsList from '../components/NotificationsList.tsx';
import Beneficios from '../components/Benefits.tsx';
import MisEventos from '../components/Events.tsx';
import Profile from '../components/Profile.tsx';
import SocioStatus from '../components/SocioStatus.tsx';
import SocioSelect from '../components/SocioSelect.tsx';
import ContratosTable from '../components/ContratosTable.tsx';
import AdminDashboard from '../components/AdminDashboard.tsx';
import CuponesGestor from '../components/Cupones.tsx';
import CuponesSocio from '../components/CuponesSocio.tsx';
import ServiciosPanel from '../components/ServiciosPanel.tsx';
import ServiciosGestor from '../components/ServiciosGestor.tsx';
import EditSocio from '../components/EditSocio.tsx';
import CreateSocio from '../components/CreateSocio.tsx';
import Institutional from '../components/Institucional.tsx';
import CajasPage from '../components/cajas/CajasPage.tsx';
import CajasPorSocio from '../components/cajas/CajasPorSocio.tsx';
import PaymentsPage from '../components/PaymentsPage.tsx';
import MovimientosPage from '../components/MovimientosPage.tsx';
import PaymentCallback from '../components/PaymentCallback.tsx';
import ServicioCrear from '../components/ServicioCrear.tsx';
import PuntosAdminPage from '../components/PuntosAdminPage.tsx';
import ProductDetailMvp from '../components/ProductDetailMvp.tsx';
import StorePageMvp from '../components/StorePageMvp.tsx';
import MisComerciosSocio from '../components/MisComerciosSocio.tsx';
import CamaraStream from '../components/CamaraStream.tsx';
import CamaraStreamAdmin from '../components/CamaraStreamAdmin.tsx';
import BolsaTrabajoAdmin from '../components/BolsaTrabajoAdmin.tsx';
import AsistenciaEnergia from '../components/AsistenciaEnergia.tsx';
import EmprendedoresOnboarding from '../components/EmprendedoresOnboarding.tsx';
import EmprendedorCuenta from '../components/EmprendedorCuenta.tsx';
import MarketplaceAdmin from '../components/MarketplaceAdmin.tsx';
import WhatsAppAdmin from '../components/WhatsAppAdmin.tsx';
import LoginRequired from '../components/LoginRequired.tsx';
import CampaniasPanel from '../components/CampaniasPanel.tsx';
import CampaniaDetalle from '../components/CampaniaDetalle.tsx';
import CampaniasGestor from '../components/CampaniasGestor.tsx';
import CampaniaCrear from '../components/CampaniaCrear.tsx';
import CategoriasGestor from '../components/CategoriasGestor.tsx';
import EventosGestor from '../components/EventosGestor.tsx';

const AppRoutes = () => {
  return (
      <Routes>
        <Route path="/" element={<Institutional />} />
        <Route path="/catalogo" element={<LoginRequired />} />
        <Route path="/insitucional" element={<Navigate to="/institucional" replace />} />
        <Route path="/institucional" element={<Institutional />} />
        <Route path="/tienda/:slug" element={<StorePageMvp />} />
        <Route path="/producto/:id" element={<ProductDetailMvp />} />
        <Route path="/emprendedores" element={<EmprendedoresOnboarding />} />
        <Route path="/emprendedores/cuenta" element={<EmprendedorCuenta />} />
        <Route path="/mercadopago/success" element={<PaymentCallback />} />
        <Route path="/mercadopago/failure" element={<PaymentCallback />} />
        <Route path="/success" element={<PaymentCallback />} />
        <Route path="/failure" element={<PaymentCallback />} />

        <Route element={<RequireAuth />}>
          <Route element={<RequireSelectedSocio />}>
            <Route path="/mis-datos" element={<Dashboard />} />
            <Route path="/inicio" element={<Dashboard />} />
            <Route path="/cuotas" element={<CuotasTable />} />
            <Route path="/servicios" element={<ServiciosPanel />} />
            <Route path="/pagos" element={<PaymentsPage />} />
            <Route path="/movimientos" element={<MovimientosPage />} />
            <Route path="/cajas" element={<CajasPage />} />
            <Route path="/mis-cajas" element={<CajasPorSocio />} />
            <Route path="/eventos" element={<MisEventos />} />
            <Route path="/perfil" element={<Profile />} />
            <Route path="/editar-perfil" element={<EditSocio/>} />
            <Route path="/status" element={<SocioStatus />} />
            <Route path="/mis-cupones" element={<CuponesSocio />} />
            <Route path="/mis-comercios" element={<MisComerciosSocio/>} />
            <Route path="/camara-stream" element={<CamaraStream/>} />
            <Route path="/asistencia-energia" element={<AsistenciaEnergia/>} />
          </Route>
          <Route path="/dashboard" element={<ContratosTable />} />
          <Route path="/contratos" element={<Navigate to="/dashboard" replace />} />
          <Route path="/notificaciones" element={<NotificationsList />} />
          <Route path="/beneficios" element={<Beneficios />} />
          <Route path="/eventos-admin" element={<EventosGestor />} />
          <Route path="/socios-nuevo" element={<CreateSocio/>} />
          <Route path="/contrato-cofres" element={<Navigate to="/dashboard" replace />} />
          <Route path="/seleccionar-socio" element={<SocioSelect />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/servicios-admin" element={<ServiciosGestor />} />
          <Route path="/categorias" element={<CategoriasGestor />} />
          <Route path="/servicios-nuevo" element={<ServicioCrear />} />
          <Route path="/cupones" element={<CuponesGestor/>} />
          <Route path="/puntos-admin" element={<PuntosAdminPage/>} />
          <Route path="/camara-stream-admin" element={<CamaraStreamAdmin/>} />
          <Route path="/bolsa-trabajo-admin" element={<BolsaTrabajoAdmin/>} />
          <Route path="/marketplace-admin" element={<MarketplaceAdmin/>} />
          <Route path="/whatsapp-admin" element={<WhatsAppAdmin/>} />
          <Route path="/campanias" element={<CampaniasPanel/>} />
          <Route path="/campanias/:id" element={<CampaniaDetalle/>} />
          <Route path="/campanias-admin" element={<CampaniasGestor/>} />
          <Route path="/campanias-nueva" element={<CampaniaCrear/>} />
          <Route path="/campanias-editar/:id" element={<CampaniaCrear/>} />
        </Route>

        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
  );
};

export default AppRoutes; 
